import { getFeatureFlips } from '../repositories/featureFlipRepository'

export default function featureFlipIsEnabled(key: string) {
  return !!getFeatureFlips()[key]
}
